export const keycloakKeys = {
  clientId: 'cinemark-internet',
} as const;

export const keycloakErrors = {
  noRefreshTokenError: 'No refresh token available',
  sessionInvalid: 'Session is not valid',
} as const;
